import { formatMoney } from 'accounting'

import { Box, ListItem, Text } from '@domain-group/suit-theme'

import type { CampaignItemModel, OrderModel } from '@models/types'

interface ActualTotalProps {
  items: CampaignItemModel[] | OrderModel[],
}

const ActualTotal = (props: ActualTotalProps) => {
  const { items } = props

  const itemsActualTotal = items.reduce((acc, item) => acc
   // @ts-expect-error TS2339
   + ((item.price_override || item.total) - (item.invoice_total || 0)), 0)

  return (
    <ListItem
      boxProps={{
        alignItems: 'center',
        borderTop: '1px solid',
        fontSize: 'small',
        justifyContent: 'space-between',
        paddingTop: 'large',
      }}
      disableHover
    >
      <Text lineHeight="1.3" style={{ whiteSpace: 'nowrap' }}>Actual Total</Text>

      <Box justifyContent="flex-end">
        <Text color="bodyFontLightColor" paddingRight={28}>{formatMoney(itemsActualTotal)}</Text>
      </Box>
    </ListItem>
  )
}

export default ActualTotal
